module.exports = __webpack_public_path__ + "media/video-m.de368dfc.mp4";